/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RemoveInputs */

const en_remove = /** @type {(inputs: RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const fr_remove = /** @type {(inputs: RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const de_remove = /** @type {(inputs: RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const it_remove = /** @type {(inputs: RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovere`)
};

const ru_remove = /** @type {(inputs: RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалять`)
};

const es_remove = /** @type {(inputs: RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const zh_cn2_remove = /** @type {(inputs: RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消除`)
};

const ja_remove = /** @type {(inputs: RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り除く`)
};

const hi_remove = /** @type {(inputs: RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निकालना`)
};

const pt_pt2_remove = /** @type {(inputs: RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {RemoveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove = /** @type {((inputs?: RemoveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RemoveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove(inputs)
	if (locale === "de") return de_remove(inputs)
	if (locale === "it") return it_remove(inputs)
	if (locale === "ru") return ru_remove(inputs)
	if (locale === "es") return es_remove(inputs)
	if (locale === "zh-CN") return zh_cn2_remove(inputs)
	if (locale === "ja") return ja_remove(inputs)
	if (locale === "hi") return hi_remove(inputs)
	if (locale === "pt-PT") return pt_pt2_remove(inputs)
	return en_remove(inputs)
});